var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIllustrationHomeVentilationActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4821_20814)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1646,
    cy: 51.0412,
    rx: 26.9883,
    ry: 26.9883,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1603,
    cy: 51.0413,
    rx: 18.9436,
    ry: 18.9436,
    fill: "url(#paint0_linear_4821_20814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7264 47.1844C51.1884 47.1844 51.6252 47.2762 52.042 47.4119V46.4718C52.042 44.5061 53.5683 42.9047 55.4434 42.9047C57.3321 42.9047 58.8686 44.5156 58.8686 46.4958H61.4518C61.4518 43.3283 58.7554 40.75 55.4423 40.75C52.1436 40.75 49.4609 43.3167 49.4609 46.4718V47.3962C49.8632 47.271 50.2822 47.1844 50.7263 47.1844L50.7264 47.1844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7448 52.6933H46.675C46.5493 52.2927 46.4634 51.8753 46.4634 51.434C46.4634 50.9728 46.5556 50.5377 46.6917 50.1225H45.7448C43.7713 50.1225 42.1643 48.6023 42.1643 46.7346C42.1643 44.8534 43.7816 43.3229 45.7697 43.3229L45.7687 40.75C42.5886 40.75 40 43.4357 40 46.7357C40 50.0213 42.5769 52.6934 45.7446 52.6934L45.7448 52.6933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6594 50.1231H54.7617C54.8979 50.5384 54.9901 50.9734 54.9901 51.4346C54.9901 51.8759 54.9031 52.2944 54.7785 52.6939H55.6605C57.6277 52.6939 59.289 54.2704 59.289 56.1339C59.289 58.0151 57.6716 59.5456 55.6846 59.5456L55.6836 62.1185C58.8637 62.1185 61.4523 59.4328 61.4523 56.1339C61.4523 52.8192 58.8534 50.123 55.6594 50.123L55.6594 50.1231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7274 55.6835C50.2833 55.6835 49.8643 55.5969 49.462 55.4717V56.3481C49.462 58.3075 47.8793 59.9622 46.0084 59.9622C44.1197 59.9622 42.5831 58.3513 42.5831 56.3722H40C40 59.5397 42.6964 62.118 46.0084 62.118C49.3363 62.118 52.0431 59.5294 52.0431 56.3481V55.4561C51.6262 55.5917 51.1894 55.6835 50.7275 55.6835L50.7274 55.6835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.728 47.6934C48.6539 47.6934 46.9727 49.369 46.9727 51.4349C46.9727 53.5018 48.6539 55.1764 50.728 55.1764C52.8021 55.1764 54.4812 53.5018 54.4812 51.4349C54.4812 49.369 52.801 47.6934 50.728 47.6934ZM50.728 54.107C49.2458 54.107 48.0453 52.9113 48.0453 51.4349C48.0453 49.9585 49.2458 48.7628 50.728 48.7628C52.2092 48.7628 53.4086 49.9585 53.4086 51.4349C53.4086 52.9113 52.2092 54.107 50.728 54.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7275 50.0977C49.9869 50.0977 49.3867 50.6965 49.3867 51.4342C49.3867 52.1729 49.9869 52.7707 50.7275 52.7707C51.4681 52.7707 52.0683 52.1729 52.0683 51.4342C52.0683 50.6965 51.4681 50.0977 50.7275 50.0977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4821_20814",
    x: 0,
    y: 0,
    width: 102.328,
    height: 102.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.114844 0 0 0 0 0.222396 0 0 0 0 0.4375 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4821_20814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4821_20814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4821_20814",
    x1: 62.579,
    y1: 39.6125,
    x2: 18.7324,
    y2: 95.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustrationHomeVentilationActive);
export default __webpack_public_path__ + "static/media/home_illustration_home_ventilation_active.89f9ac99ee40034f34be5659a3da9cb8.svg";
export { ForwardRef as ReactComponent };